import { useEffect } from 'react';
import { useHelpContext } from '../contexts/HelpWidgetContext';

/**
 * Hook to enable keyboard shortcut for toggling help widget
 * Default: Cmd+/ (Mac) or Ctrl+/ (Windows/Linux)
 */
export function useHelpShortcut(enabled = true) {
  const { toggleHelp } = useHelpContext();

  useEffect(() => {
    if (!enabled) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      // Check for Cmd+/ (Mac) or Ctrl+/ (Windows/Linux)
      const isModifierKey = event.metaKey || event.ctrlKey;
      const isSlashKey = event.key === '/' || event.code === 'Slash';

      if (isModifierKey && isSlashKey) {
        event.preventDefault();
        toggleHelp();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled, toggleHelp]);
}

export default useHelpShortcut;
